import type { IconData } from '@stacksjs/iconify-core'

export const bicycleBike: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M30 31a8 8 0 1 0 16 0a8 8 0 0 0-16 0m-12.01-.42c-2.709.17-6.084.147-8.99-.58l4.863-6.007a8 8 0 1 0 4.126 6.587Z\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M46 31a8 8 0 1 1-16 0a8 8 0 1 1 16 0\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M37 10c-4 .5-6.5 2-6.5 2L37 30.5m-5-14C30.333 19.667 23 30 23 30s-8 1.5-14 0l8.5-10.5\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.863 23.993a8 8 0 1 0 4.126 6.587M23 30c-1.711-3.765-5.507-10.735-7-14.5m4.5-1S16 14.5 12 16\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default bicycleBike
